import client from "../client";

export function getExperienceYears(page?: number) {
  return client.get(`/api/v2/experience_years${page ? `?page=${page}` : ""}`);
}
